import { LocalDate } from '@js-joda/core';

import { BindingCreator } from '@dreryk/react-common';
import { DatePicker } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../../translations';

const t = patientMedicalInformationTranslationKeys.medicalImaging.form;

const EXAMINATION_DATE_FIELD_NAME = 'examinationDate';

type ExaminationDateType = LocalDate;

export type ExaminationDateFormBeanPart = { [EXAMINATION_DATE_FIELD_NAME]: ExaminationDateType };

type ExaminationDatePickerProps = { readonly register: BindingCreator<ExaminationDateFormBeanPart> };

export const ExaminationDatePicker = (props: ExaminationDatePickerProps): JSX.Element => {
   return (
      <DatePicker
         testId={EXAMINATION_DATE_FIELD_NAME}
         controller={props.register(EXAMINATION_DATE_FIELD_NAME, { required: true })}
         label={t.examinationDate.label}
         dayValidators={'dayAfterToday'}
         withNavigationArrows
      />
   );
};
